import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

function EmailVerified({ onLoginSuccess }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      localStorage.setItem("token", token);
      onLoginSuccess("regular", token);
      navigate("/");
    }
  }, [searchParams, onLoginSuccess, navigate]);

  return (
    <div>
      <p>Verifying your email... Please wait.</p>
    </div>
  );
}

export default EmailVerified;
